module.exports = __webpack_public_path__ + "static/media/logo-mini.da23e145.svg";